import axios from 'axios';
import { toast } from 'react-toastify';

import { addInternetService, fileAttachment } from '../../Component/Helpers/api';
import { param } from 'jquery';
import $ from 'jquery';
export const AddInternetService = (param, formaData) => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  axios
    .post(addInternetService.data, param)
    .then(res => {

      if (res.data.statusCode === 200) {
        // Max two file allowed
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${fileAttachment.data}?ticketId=${res.data.data.id}`,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': authToken?.spintlyToken,
          },
          data: formaData
        };
        axios(config)
          .then((res) => {
            toast.configure();
            toast.success('Request is submitted succssfully', {
              
            })
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            $('.close').click();
          })
          .catch((error) => {
            toast.configure();
            toast.error('Unable to attach files', {
              
            })
          });
      }

    });

};




